export class NameValueInteger {
  public name: string;
  public value: number;

  public constructor(itemName?: string, itemValue?: number) {
    if (itemName == null || itemName == undefined) {
      this.name = '';
    } else {
      this.name = itemName;
    }
    if (itemValue == null || itemValue == undefined) {
      this.value = 0;
    } else {
      this.value = itemValue;
    }
  }
}
